export default __webpack_public_path__ + "static/media/LYOUNA.8b19bff0.JPG";